import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from './common';

const routes = [
    {
        matchRegex: '/Site',
        name: 'Site - Listing',
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_STATIC_SCRIPT,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_V_FORM_FILTER,
            SLOT_KEY.SLOT_V_FORM_ADVANCED_FILTER,
        ],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
                { key: 'MARKETPLACE_EVENT_TOGGLE_VIEW', label: 'Before Toogle View' },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_BATCHING',
                    label: 'Before Toogle Batching',
                },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
            ],
            [SLOT_KEY.SLOT_STATIC_SCRIPT]: [
                { key: 'add-site', label: 'Button Add Site' },
                { key: 'print', label: 'Button Print' },
                { key: 'export', label: 'Button Export' },
            ],
        },
    },
    {
        matchRegex: '/Site/Create',
        name: 'Site - Create',
        slots: [
            SLOT_KEY.SLOT_V_RIGHT_INNER_FORM_SECTION_DIALOG,
            SLOT_KEY.SLOT_V_RIGHT_FORM_SECTION_DIALOG,
            SLOT_KEY.SLOT_V_LEFT_INNER_FORM_SECTION_DIALOG,
            SLOT_KEY.SLOT_V_LEFT_FORM_SECTION_DIALOG,
            SLOT_KEY.SLOT_V_FORM_SECTION_DIALOG,
            SLOT_KEY.SLOT_V_RIGHT_INNER_FORM_SECTION,
            SLOT_KEY.SLOT_V_RIGHT_FORM_SECTION,
            SLOT_KEY.SLOT_V_LEFT_INNER_FORM_SECTION,
            SLOT_KEY.SLOT_V_LEFT_FORM_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_RIGHT_INNER_FORM_SECTION_DIALOG]: [
                { key: 'customer-create-dialog', label: 'Customer Create Dialog' },
            ],
            [SLOT_KEY.SLOT_V_RIGHT_FORM_SECTION_DIALOG]: [
                { key: 'customer-create-dialog', label: 'Customer Create Dialog' },
            ],
            [SLOT_KEY.SLOT_V_LEFT_INNER_FORM_SECTION_DIALOG]: [
                { key: 'customer-create-dialog', label: 'Customer Create Dialog' },
            ],
            [SLOT_KEY.SLOT_V_LEFT_FORM_SECTION_DIALOG]: [
                { key: 'customer-create-dialog', label: 'Customer Create Dialog' },
            ],
            [SLOT_KEY.SLOT_V_FORM_SECTION_DIALOG]: [
                { key: 'customer-create-dialog', label: 'Customer Create Dialog' },
            ],
        },
    },
    {
        matchRegex: '/Site/Detail/:id',
        name: 'Site - Detail',
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_STATIC_SCRIPT,
            SLOT_KEY.SLOT_SECTION_ACTION,
            SLOT_KEY.SLOT_V_FORM_INNER_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION,
            SLOT_KEY.SLOT_MVC_FORM_SECTION,
            SLOT_KEY.SLOT_V_FORM_INNER_SECTION,
            SLOT_KEY.SLOT_MVC_FORM_INNER_SECTION,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SECTION
        ],
        image: PreviewDetailImg,
        options: {
            [SLOT_KEY.SLOT_STATIC_SCRIPT]: [
                { key: 'log-job', label: 'Button Log Job' },
                { key: 'log-quote', label: 'Button Log Quote' },
            ],

        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'job-table', label: 'Job Table' },
                { key: 'invoice-list', label: 'Invoice Table' },
                // { key: 'ppm-contract-table', label: 'PPM Contract Table' },
                // { key: 'ppm-quote-table', label: 'PPM Quote Table' },
                // { key: 'audit-table', label: 'Audit Table' },
            ],
            [SLOT_KEY.SLOT_SECTION_ACTION]: [
                { key: 'detail-tab-form', label: 'Detail Form' },
                { key: 'billing-tab-form', label: 'Billing Form' },
                { key: 'configuration-tab-form', label: 'Configuration Form' },
                { key: 'warning-notices-tab-form', label: 'Warning Notices Form' },
            ],
            [SLOT_KEY.SLOT_V_FORM_SECTION]: [{ key: 'site-detail-tab', label: 'Site Detail Tab' }],
            [SLOT_KEY.SLOT_MVC_FORM_SECTION]: [
                { key: 'warning-notices-tab', label: 'Warning Notices Tab' },
                { key: 'configuration-tab', label: 'Configuration Tab' },
            ],
            [SLOT_KEY.SLOT_V_FORM_INNER_SECTION]: [
                { key: 'warning-notices-tab', label: 'Warning Notices Tab' },
                { key: 'configuration-tab', label: 'Configuration Tab' },
                { key: 'site-detail-tab', label: 'Site Detail Tab' }
            ],
            [SLOT_KEY.SLOT_MVC_FORM_INNER_SECTION]: [
                { key: 'billing-tab', label: 'Billing Tab' },
            ],
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'section-search-job-filter', label: 'Advanced Search Filter' },
            ],
        },
    },
]

export default routes;